module.exports = __webpack_public_path__ + "static/img/loading.a6f0a8b.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/img/loading.png
// module id = 1960
// module chunks = 153